import {
  AUTH_COOKIE,
  IS_SECURED_COOKIE,
  REFRESH_AUTH_COOKIE
} from "../const/cookies.mjs";
export function isHavingNewToken(response) {
  return !!(response.body.data && response.body.data.response && response.body.data.response.token && response.body.data.response.refreshToken);
}
export function getAuthCookie(request) {
  if (request.headers.source === "server") {
    return (request.headers && request.headers[AUTH_COOKIE]?.toString()) ?? null;
  }
  return request.cookies && request.cookies[AUTH_COOKIE];
}
export function setCookie(res, token) {
  res.cookie(AUTH_COOKIE, token.token, {
    secure: true,
    httpOnly: true,
    expires: new Date(Number(token.token_expires_at) * 1e3)
  });
  res.cookie(IS_SECURED_COOKIE, true, {
    secure: false,
    httpOnly: false,
    expires: new Date(Number(token.token_expires_at) * 1e3)
  });
}
export function clearCookie(res) {
  res.clearCookie(AUTH_COOKIE);
  res.clearCookie(IS_SECURED_COOKIE);
}
export function setSpaCookie(payload) {
  const { token, expiresAt, refreshToken, refreshTokenExpiresAt } = payload;
  document.cookie = `${AUTH_COOKIE}=${token};  expires=${new Date(
    expiresAt * 1e3
  ).toUTCString()}`;
  document.cookie = `${IS_SECURED_COOKIE}=true;  expires=${new Date(
    expiresAt * 1e3
  ).toUTCString()}`;
  document.cookie = `${REFRESH_AUTH_COOKIE}=${refreshToken};  expires=${new Date(
    refreshTokenExpiresAt * 1e3
  ).toUTCString()}`;
}
export function clearSpaCookies() {
  document.cookie = `${AUTH_COOKIE}=;  expires=${(/* @__PURE__ */ new Date(0)).toUTCString()}`;
  document.cookie = `${IS_SECURED_COOKIE}=;  expires=${(/* @__PURE__ */ new Date(
    0
  )).toUTCString()}`;
  document.cookie = `${REFRESH_AUTH_COOKIE}=;  expires=${(/* @__PURE__ */ new Date(
    0
  )).toUTCString()}`;
}
